import { GET_CATEGORIES_LIST } from "App.constants";

export const getCategoriesList = () => ({type: GET_CATEGORIES_LIST})
